import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useGetTableauTokenMutation } from '../../features/tenant/tableau/dashboardApi';
import { TableauViz } from '@tableau/embedding-api-react';

const TableauDashboard2 = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tableauToken, setTableauToken] = useState("");
  const [tableauViewUrl, setTableauViewUrl] = useState(null);

  const [
    getTableauJWT,
    { data: tableauTokenData, error: tableauTokenError },
  ] = useGetTableauTokenMutation();

  useEffect(() => {
    getTableauJWT({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }, []);

  useEffect(() => {
    setError("");
    console.log("tableauTokenData", tableauTokenData);
    if (!tableauTokenData || !tableauTokenData.body) {
      setError("Tableau data is empty");
      return;
    }
    loadDashboard(tableauTokenData.body);
  }, [tableauTokenData]);

  const handleSignIn = () => {
    getTableauJWT({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  };

  const loadDashboard = (tableauData) => {
    if (!tableauData.url) {
      setError("Tableau url not found");
      return;
    }
    if (!tableauData.token) {
      setError("Tableau token not found");
      return;
    }
    setTableauToken(tableauData.token);
    // Store token in session
    // sessionStorage.setItem('tableau_token', tableauData.token);
    
    let url = tableauData.url;
    url = url.replace("token", tableauData.token);
    url += "?:embed=yes&:comments=no&:toolbar=yes&:refresh=yes"
    console.log("url: "+url);

    setTableauViewUrl(url);
    console.log("tableauViewUrl: "+tableauViewUrl);
  };

  if (loading) {
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <CircularProgress />
        <div style={{ marginTop: '1rem' }}>Loading Dashboard...</div>
      </div>
    );
  }

  return (
    <div className="flex flex-column w-full bg-gray-200 h-full justify-center">
      <div className="w-full">
      {error}
      {/* (<p>{tableauViewUrl}</p>) */}
      </div>
      {tableauViewUrl && (
        <TableauViz
          src={tableauViewUrl}
          token={tableauToken}
          toolbar="bottom"
          debug={false}
          hideTabs
        ></TableauViz>
      )}
    </div>
  );
};

export default TableauDashboard2;
